import * as React from "react";
import { Fragment, ReactNode } from "react";
import { CountryProperty, findOne } from "country-codes-list";

export type AddressType = {
  countryCode?: string;
  line1: string;
  line2?: Maybe<string>;
  city: string;
  state?: string;
  postcode: string;
};

const getAddressFragments = (address: AddressType): ReactNode[] => {
  const country = address.countryCode
    ? findOne("countryCode" as CountryProperty, address.countryCode)?.countryNameEn
    : null;
  const isUS = address.countryCode === "US";
  const cityLine =
    isUS && address.city && address.state && address.postcode
      ? `${address.city}, ${address.state} ${address.postcode}`
      : null;
  const lines = cityLine
    ? [country, address.line1, address.line2, cityLine]
    : [country, address.line1, address.line2, address.city, address.state, address.postcode];
  return lines
    .filter((l): l is string => typeof l === "string" && l !== "")
    .map((line, i) => (
      <Fragment key={i}>
        {line}
        <br />
      </Fragment>
    ));
};

export const Address: React.FC<{ value: AddressType }> = ({ value }) => <address>{getAddressFragments(value)}</address>;
